/* Attribution Service */
import './apps/bankrate-cookie'

/* JS for Accordion Shortcodes built in Wordpress */
import './accordions'

/* Ensure external links open new window */
import './all-targets-blank'

/* Reports clicks on "You May Also Like" articles to Tagular */
import './article/related-articles-tracking'
